import AlertaGuardado from 'components/comun/AlertaGuardado';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, CardBody, CardHeader, Col, Form, FormGroup, Input, Label, Modal, Row } from 'reactstrap'
import { apiCentrosService } from 'services/apiCentrosService';
import { showAppAlert } from "components/common/AppAlerts";

const DetalleCentro = () => {
  const { id } = useParams();
  const navigate = useNavigate()
  const [nombre, setNombre] = useState("");
  const [direccion, setDireccion] = useState("");
  const [comentarios, setComentarios] = useState("");


  const [status, setStatus] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const json = {
      nombre: nombre,
      direccion: direccion,
      comentarios: comentarios
    }
    const response = await apiCentrosService.putById(id, json);
    setStatus(response.message)
    await new Promise(resolve => setTimeout(resolve, 2000));
    setStatus("")
  }
  const handleDelete = async (e) => {
    e.preventDefault();
   
    const response = await apiCentrosService.deleteById(id);
    if(response.message === "saved"){
      showAppAlert("Se ha eliminado correctamente", "success");
      navigate("/admin/centros")
    }else{
      showAppAlert("No se ha podido eliminar, hay elementos enlazados.", "error")
    }
  
  }



  const [modalOpen, setModalOpen] = useState(false)

  const toggleModal = () => {
    setModalOpen(!modalOpen)
  }

  useEffect(() => {
    const fetchData = async () => {
      const response = await apiCentrosService.getById(id)
      setNombre(response.nombre)
      setDireccion(response.direccion)
      setComentarios(response.comentarios)

    }

    fetchData();
  }, [id])


  return (
    <>
      <Card>
        <Form onSubmit={handleSubmit}>
          <CardHeader>
            Centro: {id}
          </CardHeader>
          <CardBody>
            <Row>
              <Col lg={12}>
                <FormGroup>
                  <Label htmlFor="nombre" className="form-control-label">
                    Nombre:
                  </Label>
                  <Input
                    type="text"
                    name="nombre"
                    className="form-control-alternative"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    required
                  ></Input>
                </FormGroup>
              </Col>
              <Col lg={12}>
                <FormGroup>
                  <Label htmlFor="direccion" className="form-control-label">
                    Dirección:
                  </Label>
                  <Input
                    type="text"
                    name="direccion"
                    className="form-control-alternative"
                    value={direccion}
                    onChange={(e) => setDireccion(e.target.value)}

                  ></Input>
                </FormGroup>
              </Col>
              <Col lg={12}>
                <FormGroup>
                  <Label htmlFor="comentarios" className="form-control-label">
                    Comentarios:
                  </Label>
                  <Input
                    type="textarea"
                    name="comentarios"
                    className="form-control-alternative"
                    value={comentarios}
                    onChange={(e) => setComentarios(e.target.value)}

                  ></Input>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
          <CardHeader className='text-right'>
            <Button color='success' type='submit'>Guardar</Button>

            <Button color='danger' onClick={() => toggleModal()}>Eliminar</Button>
            <Button color='secondary' onClick={() => navigate("/admin/centros")}>Volver</Button>
          </CardHeader>
        </Form>
      </Card>
      <AlertaGuardado status={status}></AlertaGuardado>
      <Modal
        className="modal-dialog-centered"
        isOpen={modalOpen}
      >
        <div className="modal-header">
          <h2 className="modal-title" id="exampleModalLabel">
            ¿Está seguro que quiere eliminarlo?
          </h2>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => toggleModal()}
          >
            <span aria-hidden={true}>x</span>
          </button>
        </div>
        <div className="modal-body text-right">

          <Button  color='danger' onClick={handleDelete}>Sí</Button>
          <Button  color='secondary' onClick={() => toggleModal()}>No</Button>
        </div>

      </Modal>
    </>
  )
}

export default DetalleCentro


